import { EditButton, usePermissions } from 'react-admin'
import React from 'react'

const VisitEditButton = (props) => {
  const { record } = props

  const { permissions } = usePermissions()

  return <EditButton {...props} disabled={!permissions?.inspection.canEdit(record)} />
}

export default VisitEditButton
